// @module BluePoint.OrderTotalFix.OrderTotalFix
define('BluePoint.OrderTotalFix.OrderTotalFix.View'
,	[
	'bluepoint_ordertotalfix_ordertotalfix.tpl'
	
	,	'BluePoint.OrderTotalFix.OrderTotalFix.SS2Model'
	
	,	'Backbone'
    ]
, function (
	bluepoint_ordertotalfix_ordertotalfix_tpl
	
	,	OrderTotalFixSS2Model
	
	,	Backbone
)
{
    'use strict';

	// @class BluePoint.OrderTotalFix.OrderTotalFix.View @extends Backbone.View
	return Backbone.View.extend({

		template: bluepoint_ordertotalfix_ordertotalfix_tpl

	,	initialize: function (options) {

			/*  Uncomment to test backend communication with an example service
				(you'll need to deploy and activate the extension first)
			*/

			// this.model = new OrderTotalFixModel();
			// var self = this;
         	// this.model.fetch().done(function(result) {
			// 	self.message = result.message;
			// 	self.render();
      		// });
		}

	,	events: {
		}

	,	bindings: {
		}

	, 	childViews: {

		}

		//@method getContext @return BluePoint.OrderTotalFix.OrderTotalFix.View.Context
	,	getContext: function getContext()
		{
			//@class BluePoint.OrderTotalFix.OrderTotalFix.View.Context
			this.message = this.message || 'Hello World!!'
			return {
				message: this.message
			};
		}
	});
});
